<template>
  <el-dialog title="财务导出记录" :visible="visible" width="92%" top="5vh"
    :close-on-click-modal="false" @close="close">
    <el-form :inline="true" size="small" @submit.native.prevent>
      <el-form-item label="下载类型">
        <el-select v-model="filters.exportType" clearable placeholder="全部" style="width: 190px">
          <el-option v-for="item in exportTypes" :key="item.value"
            :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="filters.status" clearable placeholder="全部" style="width: 130px">
          <el-option label="待做单" value="PENDING"></el-option>
          <el-option label="已完成" value="CONFIRMED"></el-option>
          <el-option label="已作废" value="CANCELLED"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="rows" border size="small" max-height="560">
      <el-table-column prop="batchNo" label="财务批次号" min-width="210"></el-table-column>
      <el-table-column prop="exportName" label="下载类型" min-width="155"></el-table-column>
      <el-table-column label="数据时间范围" min-width="290">
        <template slot-scope="scope">
          {{ formatTime(scope.row.startTime) }} 至 {{ formatTime(scope.row.endTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="rowCount" label="明细行数" width="90" align="right"></el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="statusType(scope.row.status)" size="small">{{ statusName(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="生成人" min-width="145">
        <template slot-scope="scope">
          <div>{{ scope.row.createBy || '-' }}</div>
          <div class="time-text">{{ formatTime(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="确认人" min-width="145">
        <template slot-scope="scope">
          <div>{{ scope.row.confirmBy || '-' }}</div>
          <div v-if="scope.row.confirmTime" class="time-text">{{ formatTime(scope.row.confirmTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="235" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status !== 'CANCELLED'" type="text" icon="el-icon-download"
            @click="download(scope.row)">重新下载</el-button>
          <el-button v-if="scope.row.status === 'PENDING'" type="text" icon="el-icon-check"
            @click="confirm(scope.row)">确认已做单</el-button>
          <el-button v-if="scope.row.status === 'PENDING'" type="text" icon="el-icon-close"
            class="danger-action" @click="cancel(scope.row)">作废</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="pagination" background layout="total, sizes, prev, pager, next"
      :total="total" :current-page="page" :page-size="size" :page-sizes="[10, 20, 50]"
      @current-change="changePage" @size-change="changeSize"></el-pagination>
    <span slot="footer">
      <el-button icon="el-icon-close" @click="close">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  getFinanceExportBatchPage,
  downloadFinanceExportBatch,
  confirmFinanceExportBatch,
  cancelFinanceExportBatch
} from "@/api/work/financeExportBatch";

export default {
  name: "FinanceExportBatchDialog",
  props: {
    visible: { type: Boolean, default: false },
    projectType: { type: String, required: true }
  },
  data() {
    return {
      loading: false,
      rows: [],
      total: 0,
      page: 1,
      size: 10,
      filters: { exportType: "", status: "" }
    };
  },
  computed: {
    exportTypes() {
      if (this.projectType === "WATERPROOF") {
        return [
          { value: "WATERPROOF_COST", label: "防水费用拆分" },
          { value: "WATERPROOF_PENDING_WRITE_OFF", label: "防水待核销材料" },
          { value: "WATERPROOF_WRITTEN_OFF", label: "防水已核销材料" }
        ];
      }
      return [
        { value: "HANG_CEILING_COST", label: "吊顶费用拆分" },
        { value: "HANG_CEILING_PENDING_WRITE_OFF", label: "吊顶待核销材料" },
        { value: "HANG_CEILING_WRITTEN_OFF", label: "吊顶已核销材料" },
        { value: "HANG_CEILING_RETURN", label: "吊顶退货材料" }
      ];
    }
  },
  watch: {
    visible(value) {
      if (value) this.load();
    }
  },
  methods: {
    load() {
      this.loading = true;
      getFinanceExportBatchPage({
        projectType: this.projectType,
        exportType: this.filters.exportType || undefined,
        status: this.filters.status || undefined,
        page: this.page - 1,
        size: this.size
      }).then(res => {
        this.rows = res.rows || [];
        this.total = Number(res.total || 0);
      }).then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    search() {
      this.page = 1;
      this.load();
    },
    reset() {
      this.filters = { exportType: "", status: "" };
      this.search();
    },
    changePage(page) {
      this.page = page;
      this.load();
    },
    changeSize(size) {
      this.size = size;
      this.page = 1;
      this.load();
    },
    download(row) {
      downloadFinanceExportBatch(row.id).then(response => {
        this.saveFile(response, `${row.exportName}-${row.batchNo}.xlsx`);
      });
    },
    confirm(row) {
      this.$confirm(`确认批次 ${row.batchNo} 已经在外部财务系统做单？`, "确认已做单", {
        type: "warning",
        confirmButtonText: "确认已完成",
        cancelButtonText: "取消"
      }).then(() => confirmFinanceExportBatch(row.id)).then(() => {
        this.$message.success("已确认，批次数据将永久排除在新下载之外");
        this.load();
      }).catch(() => {});
    },
    cancel(row) {
      this.$confirm(`作废批次 ${row.batchNo} 后，其中数据会重新进入待下载范围。是否继续？`, "作废批次", {
        type: "warning",
        confirmButtonText: "确认作废",
        cancelButtonText: "取消"
      }).then(() => cancelFinanceExportBatch(row.id)).then(() => {
        this.$message.success("批次已作废，来源数据已释放");
        this.load();
      }).catch(() => {});
    },
    saveFile(response, fallbackName) {
      const disposition = response.headers["content-disposition"] || "";
      const matched = disposition.match(/filename=(.*)/);
      let filename = matched ? matched[1].replace(/^\"|\"$/g, "") : fallbackName;
      try { filename = decodeURI(filename); } catch (e) { filename = fallbackName; }
      const blob = new Blob([response.data], { type: "application/octet-stream" });
      if (typeof window.navigator.msSaveBlob !== "undefined") {
        window.navigator.msSaveBlob(blob, filename);
        return;
      }
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    statusName(status) {
      return { PENDING: "待做单", CONFIRMED: "已完成", CANCELLED: "已作废" }[status] || status;
    },
    statusType(status) {
      return { PENDING: "warning", CONFIRMED: "success", CANCELLED: "info" }[status] || "";
    },
    formatTime(value) {
      if (!value) return "-";
      const date = new Date(Number(value));
      const pad = number => String(number).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
        `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    close() {
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style scoped>
.pagination {
  margin-top: 16px;
  text-align: right;
}
.time-text {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
.danger-action {
  color: #f56c6c;
}
</style>
